<template>
  <div
    class="flex justify-between items-center mb-5"
    :class="{
      'opacity-50 cursor-not-allowed': isDisabledSetting,
    }"
  >
    <div class="flex items-center flex-grow group">
      <div class="w-6 text-left">
        <aha-icon
          name="streak"
          class="text-base-70"
          width="23"
          height="20"
        ></aha-icon>
      </div>
      <span class="px-2 font-normal">{{ $i18nPresenter.t('Streak answer point bonus') }}</span>
      <b-button
        v-tooltip="streakBonusTooltip"
        class="text-secondary-40 cursor-pointer hidden group-hover:inline-block"
      >
        <i class="fas fa-question-circle" />
      </b-button>
    </div>
    <toggle-button
      v-model="presentation.isEnableStreakBonus"
      :disabled="isDisabledSetting"
      :width="35"
      :height="20"
      class="mb-0"
      :color="{
        checked: '#348EF6',
        unchecked: '#D3D7E1'
      }"
      @change="onChangeStreakBonus()"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/util'
import eventCategories from '@/constant/eventCategories'

export default {
  props: {
    isDisableEditPresentation: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
    streakBonusTooltip() {
      return {
        content: `
          Bonus rule:
          <ul class="list-disc list-inside pl-2">
            <li>2 correct: +10% max points</li>
            <li>3 correct: +20% max points</li>
            <li>4 correct: +30% max points</li>
            <li>5 correct: +40% max points</li>
            <li>6+ correct: +50% max points</li>
          </ul>
        `,
      }
    },
    isDisabledSetting() {
      return this.isDisableEditPresentation || !this.presentation.isEnableStreakDetection
    },
  },
  methods: {
    onChangeStreakBonus() {
      this.$emit('updatePresentation', {
        isEnableStreakBonus: this.presentation.isEnableStreakBonus,
      })
      if (this.presentation.isEnableStreakBonus) {
        utils.mixpanelTracking(
          eventCategories.PRESENTATION_EDITOR,
          'Settings menu > Quiz settings > Enable streak bonus > Enable',
        )
      } else {
        utils.mixpanelTracking(
          eventCategories.PRESENTATION_EDITOR,
          'Settings menu > Quiz settings > Enable streak bonus > Disable',
        )
      }
    },
  },
}
</script>
